<div
  #layerContainer
  class="text-selection-layer"
  [class.disabled]="disabled"
  [style.width.px]="canvasWidth"
  [style.height.px]="canvasHeight"
  [style.left.px]="canvasOffsetX"
  [style.top.px]="canvasOffsetY"
  tabindex="-1"
  [attr.aria-label]="'Selectable document text layer. ' + dragSelectHint + '; ' + wordSelectHint + '.'"
>
  @for (entry of selectableUnits; track entry.index) {
    @let unit = entry.unit;
    @let b = getDisplayBox(unit.box);
    <span
      class="text-unit-span"
      [attr.data-unit-index]="entry.index"
      [style.left.px]="b.x"
      [style.top.px]="b.y"
      [style.width.px]="b.width"
      [style.height.px]="b.height"
      [style.transform]="rotation(b)"
    >
      <span
        class="text-unit-glyphs"
        [style.font-size.px]="b.height"
        [style.line-height.px]="b.height"
        [style.transform]="scaleTransform(b, unit.text)"
        >{{ unit.text }}</span
      >
    </span>
  }

  <!-- Contextual Action Bar -->
  @if (hasActiveSelection && actionBarPosition) {
    <div
      class="selection-action-bar"
      [style.left.px]="actionBarPosition.x"
      [style.top.px]="actionBarPosition.y"
      role="toolbar"
      aria-label="Text selection actions"
      (mousedown)="$event.stopPropagation()"
    >
      <button
        type="button"
        mat-button
        class="action-btn copy-btn"
        (click)="copySelectedText()"
        matTooltip="Copy clean text (Ctrl+C)"
        aria-label="Copy selected text"
      >
        <mat-icon>content_copy</mat-icon>
        <span>Copy</span>
      </button>
      <div class="action-divider" aria-hidden="true"></div>
      <button
        type="button"
        mat-button
        class="action-btn chat-btn"
        (click)="useInChat()"
        matTooltip="Attach quote to chat prompt"
        aria-label="Use selected text in chat"
      >
        <mat-icon>chat</mat-icon>
        <span>Use in chat</span>
      </button>
      <div class="action-divider" aria-hidden="true"></div>
      <span class="word-select-hint" data-testid="text-selection-word-hint">{{ wordSelectHint }}</span>
    </div>
  }
</div>
